import * as actions from './feeds.actions';
import * as mutations from './feeds.mutations';
import * as getters from './feeds.getters';
import state from './feeds.state';
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const feeds = {
  namespaced,
  getters,
  mutations,
  actions,
  state,
};

export default feeds;
